import { render } from "./SinglePaddleView.vue?vue&type=template&id=6292809a&scoped=true"
import script from "./SinglePaddleView.vue?vue&type=script&lang=js"
export * from "./SinglePaddleView.vue?vue&type=script&lang=js"

import "./SinglePaddleView.vue?vue&type=style&index=0&id=6292809a&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6292809a"]])

export default __exports__